<template>
  <v-dialog v-model="internalValue" max-width="520" persistent>
    <v-card class="announce-card" rounded="xl">
      <!-- Header -->
      <div class="announce-header">
        <div class="announce-header-left">
          <div class="announce-icon-wrap">
            <v-icon size="22" color="white">mdi-bullhorn</v-icon>
          </div>
          <div>
            <div class="announce-label">Announcement</div>
            <div class="announce-date">
              {{ formatDate(currentAnnouncement?.published_at) }}
            </div>
          </div>
        </div>
        <v-btn icon size="small" variant="text" @click="close">
          <v-icon color="#708083">mdi-close</v-icon>
        </v-btn>
      </div>

      <v-divider />

      <!-- Body -->
      <div class="announce-body">
        <!-- Image if available -->
        <v-img
          v-if="currentAnnouncement?.image_url"
          :src="currentAnnouncement.image_url"
          max-height="300"
          contain
          class="rounded-lg mb-4 announcement-image-bg"
        ></v-img>

        <h2 class="announce-title">{{ currentAnnouncement?.title }}</h2>
        <div class="announce-text-content">
          {{ currentAnnouncement?.body }}
        </div>

        <!-- Navigation if multiple -->
        <div
          v-if="totalAnnouncements > 1"
          class="announce-nav mt-4 d-flex align-center justify-center ga-4"
        >
          <v-btn
            icon="mdi-chevron-left"
            variant="tonal"
            size="small"
            color="#00363F"
            :disabled="currentIndex === 0"
            @click="prev"
          ></v-btn>
          <span class="text-caption font-weight-bold"
            >{{ currentIndex + 1 }} / {{ totalAnnouncements }}</span
          >
          <v-btn
            icon="mdi-chevron-right"
            variant="tonal"
            size="small"
            color="#00363F"
            :disabled="currentIndex === totalAnnouncements - 1"
            @click="next"
          ></v-btn>
        </div>
      </div>

      <v-divider />

      <!-- Footer -->
      <div class="announce-footer">
        <!-- <v-btn variant="text" color="#708083" @click="close">Dismiss</v-btn> -->
        <v-btn color="#00363F" rounded="lg" @click="close">Got it</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AnnouncementsModal",
  props: {
    modelValue: Boolean,
    announcements: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
    currentAnnouncement() {
      return this.announcements[this.currentIndex] || null;
    },
    totalAnnouncements() {
      return this.announcements.length;
    },
  },
  watch: {
    modelValue(newVal) {
      if (newVal) {
        this.currentIndex = 0;
      }
    },
  },
  methods: {
    close() {
      this.internalValue = false;
    },
    next() {
      if (this.currentIndex < this.totalAnnouncements - 1) {
        this.currentIndex++;
      }
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      return new Date(dateStr).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
};
</script>

<style scoped>
/* Scoped styles based on HomeView.vue design */
.announce-card {
  overflow: hidden;
  border: 1px solid #eef0f2;
}

.announce-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(180deg, #fff 0%, #f9fbfc 100%);
}

.announce-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.announce-icon-wrap {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #00363f, #00a896);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.announce-label {
  font-weight: 700;
  font-size: 15px;
  color: #00363f;
}

.announce-date {
  font-size: 11px;
  color: #708083;
  margin-top: 1px;
}

.announce-body {
  padding: 24px 24px 20px;
}

.announce-title {
  font-size: 20px;
  font-weight: 700;
  color: #01252b;
  margin-bottom: 10px;
}

.announce-text-content {
  font-size: 14px;
  color: #596a6d;
  line-height: 1.7;
  max-height: 250px;
  overflow-y: auto;
  white-space: pre-wrap;
}

.announce-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
}

.gap-4 {
  gap: 16px;
}

.announcement-image-bg {
  background-color: #f8fafc;
  border: 1px solid #eef0f2;
}
</style>
